import TierGroup from "@/views/editor/service/promotion/tier_group";
import {INewBusiness} from "@/views/editor/service/business";

export default {'tier_group': TierGroup} as { [key: string]: INewBusiness }